// @ts-nocheck
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useMediaQuery,
} from "@chakra-ui/react";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  FaCheck,
  FaChevronDown,
  FaChevronRight,
  FaChevronUp,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../ApiClient/GetApi";
import Header from "../layout/Header";
import Moment from "react-moment";
import OrderStatus from "./OrderStatus";
import { Loader2 } from "../../loader/Loader";

export default function OrderDetails() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const closeModal = () => {
    setModal(false);
  };

  const payment_details = (id) => {
    localStorage.setItem("orderId", id);
    navigate("/payment_details");
  };

  const openModal = () => {
    setModal(true);
  };
  const [dropdown, setDropdown] = useState(false);
  const openDropdown = () => {
    setDropdown(true);
  };
  const closeDropdown = () => {
    setDropdown(false);
  };

  const [dropdown1, setDropdown1] = useState(false);
  const openDropdown1 = () => {
    setDropdown1(true);
  };
  const closeDropdown1 = () => {
    setDropdown1(false);
  };


  const [dropdown2, setDropdown2] = useState(false);
  const openDropdown2 = () => {
    setDropdown2(true);
  };
  const closeDropdown2 = () => {
    setDropdown2(false);
  };

  const [dropdown3, setDropdown3] = useState(false);
  const openDropdown3 = () => {
    setDropdown3(true);
  };
  const closeDropdown3 = () => {
    setDropdown3(false);
  };
  const [dropdown4, setDropdown4] = useState(false);
  const openDropdown4 = () => {
    setDropdown4(true);
  };
  const closeDropdown4 = () => {
    setDropdown4(false);
  };
  const [dropdown5, setDropdown5] = useState(false);
  const openDropdown5 = () => {
    setDropdown5(true);
  };
  const closeDropdown5 = () => {
    setDropdown5(false);
  };
  const [xl] = useMediaQuery("(min-width: 1280px)");
  const [md] = useMediaQuery("(min-width: 768px)");
  const [sm] = useMediaQuery("(min-width: 640px)");
  const [xs] = useMediaQuery("(min-width: 425px)");
  const tdStyle = "font-normal text-base text-black text-opacity-60 py-2";
  const tdStyle2 =
    "font-normal text-base text-black py-2 sm:pl-16 pl-6 max-w-[340px]";
  const [waybill, setWaybill] = useState(false);

  const toggleWayBill = () => {
    setWaybill(!waybill);
  };

  const printWayBill = () => {
    setWaybill(true);
  };
  const closeWaybill = () => {
    setWaybill(false);
  };

  const { data } = useFetch(
    `booking/booking_detail/${localStorage.getItem("orderId")}`
  );

  useEffect(() => {
    if (!waybill) return;
    const timer = setTimeout(() => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          window.print();
        });
      });
    }, 250);

    const afterPrintHandler = () => setWaybill(false);
    window.addEventListener("afterprint", afterPrintHandler);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("afterprint", afterPrintHandler);
    };
  }, [waybill]);

  const review_order = (id) => {
    navigate("/reviews", { state: { bookingId: id } });
  };

  const liStyle =
    "border border-black font-normal sm:text-base text-xs text-black py-2 sm:px-3 px-1 whitespace-nowrap";

  return (
    <section className="font-soehne">
      <Header />
      <Modal
        isOpen={modal}
        onClose={closeModal}
        size={`${xl ? "3xl" : md ? "2xl" : sm ? "xl" : xs ? "sm" : "xs"}`}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <div
              className="inline border-2 border-black border-opacity-60 px-1.5 float-right 
              rounded-fullest cursor-pointer sm:text-black"
              onClick={closeModal}
            >
              <FontAwesomeIcon
                icon={faMultiply}
                className="text-black text-opacity-60"
              />
            </div>
            <p className="text-4xl text-themeBlue font-semibold text-center py-4">
              Order Tracking
            </p>
            <div className="sm:space-y-10 space-y-6 md:py-10 py-6 md:px-4 sm:px-2">
              {data?.data?.status?.map((status, index) =>
                status?.status ? (
                  <OrderStatus
                    check={<FaCheck size={24} />}
                    status={status?.title}
                    date={status?.date}
                  />
                ) : (
                  <OrderStatus
                    check={""}
                    status={status?.title}
                    date={status?.date}
                  />
                )
              )}
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
      {data?.length === 0 ? (
        <div className="flex justify-center items-centen h-screen w-full">
          <Loader2 />
        </div>
      ) : (
        <section
          className={`xl:w-5/6 w-11/12 bg-themeGray2 mx-auto lg:my-20 my-12 sm:py-10 py-6 sm:px-8 px-4 
            rounded-lg space-y-8 ${waybill ? "hidden" : "block"}`}
        >
          <div className="flex lg:flex-row flex-col gap-5 justify-between">
            <div className="flex items-center gap-x-4">
              <div className="w-12 h-12 bg-white rounded-fullest flex justify-center items-center">
                <img
                  src="images/sendParcel/box.webp"
                  alt="box"
                  className="w-6"
                />
              </div>
              <h1 className="font-medium text-2xl text-themeBlue">
                Order#{data?.data?.order?.id ?? ""}
              </h1>
            </div>
            <div className="flex justify-between items-center gap-3 flex-shrink-0 flex-wrap">
              <button
                onClick={() => {
                  printWayBill();
                }}
                className="font-normal text-xl text-themeBlue underline"
              >
                Print WayBill
              </button>
              <button
                className="font-normal text-xl text-themeBlue underline"
                onClick={() => payment_details(data?.data?.order?.id)}
              >
                Make Payment
              </button>
            </div>
            <div className="flex sm:flex-row flex-col gap-5">
              <div className="flex gap-x-4">
                <div className="w-12 h-12 bg-themeBlue6 rounded-lg flex justify-center items-center">
                  <img
                    src="images/myOrders/box-check.webp"
                    alt="box"
                    className="w-6"
                  />
                </div>
                <div>
                  <h6 className="font-medium text-xl">
                    {" "}
                    <Moment format="D MMM , YYYY hh:mm a">
                      {data?.data?.order?.startDate ?? ""}
                    </Moment>
                  </h6>
                  <p className="font-normal text-base text-black text-opacity-60">
                    Date Created
                  </p>
                </div>
              </div>
              <div className="flex gap-x-4">
                <div className="w-12 h-12 bg-themePink rounded-lg flex justify-center items-center">
                  <img
                    src="images/myOrders/time.webp"
                    alt="box"
                    className="w-6"
                  />
                </div>
                <div>
                  <h6 className="font-medium text-xl">
                    {" "}
                    <Moment format="D MMM , YYYY hh:mm a">
                      {data?.data?.order?.expectedHubArrivalDate ?? ""}
                    </Moment>
                  </h6>
                  <p className="font-normal text-base text-black text-opacity-60">
                    Expected Hub Arrival Date
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="grid lg:grid-cols-2 gap-x-8 gap-y-8">
            <div className="space-y-6">
              <div className="bg-white py-6 px-5 rounded-lg space-y-10">
                <div className="grid grid-cols-2 gap-2">
                  <div className="flex flex-col items-start sm:gap-y-3 gap-y-1">
                    <div className="font-medium sm:text-2xl text-xl text-themeRed">
                      <Moment format="D MMM , YYYY hh:mm a">
                        {data?.data?.order?.startDate ?? ""}
                      </Moment>
                    </div>
                    <div className="font-medium text-base text-black text-opacity-60">
                      Order {data?.data?.order?.bookingStatus ?? ""}
                    </div>
                  </div>
                  <div className="flex flex-col sm:gap-y-3 gap-y-1">
                    <div className="font-medium sm:text-2xl text-xl text-themeRed">
                      <Moment format="D MMM , YYYY hh:mm a">
                        {data?.data?.order?.expectedHubArrivalDate ?? ""}
                      </Moment>
                    </div>
                    <div className="font-medium text-base text-black text-opacity-60">
                      Estd. Arrival Date at Hub
                    </div>
                  </div>
                </div>
                <div className="space-y-7">
                  <div className="grid grid-cols-6 lg:gap-x-6 sm:gap-x-4 gap-x-2 items-center">
                    {data?.data?.status?.map((status, index) => (
                      <>
                        {status?.status ? (
                          <div className="w-full h-3 bg-themeBlue rounded-md"></div>
                        ) : status?.status ? (
                          <div className="w-full h-3 bg-themeBlue rounded-md"></div>
                        ) : status?.status ? (
                          <div className="w-full h-3 bg-themeBlue rounded-md"></div>
                        ) : status?.status ? (
                          <div className="w-full h-3 bg-themeBlue rounded-md"></div>
                        ) : status?.status ? (
                          <div className="w-full h-3 bg-themeBlue rounded-md"></div>
                        ) : status?.status ? (
                          <div className="w-full h-3 bg-themeBlue rounded-md"></div>
                        ) : (
                          <div className="w-full h-3 bg-gray-300 rounded-md"></div>
                        )}
                      </>
                    ))}
                  </div>
                  <div className="flex sm:flex-row flex-col gap-y-2 justify-between items-center">
                    <button
                      onClick={() => review_order(data?.data?.order?.id)}
                      className="flex items-center gap-x-2 bg-themeYellowLight w-fit px-2 py-1"
                    >
                      <div>
                        <img
                          src="images/dashboard/review.webp"
                          alt="review"
                          className="w-6"
                        />
                      </div>
                      <span className="font-normal text-sm underline">
                        Notes
                      </span>
                      <div
                        className="font-normal text-xs text-white bg-themeYellow w-5 h-5 flex 
                      justify-center items-center rounded-fullest"
                      >
                        <span>{data?.data?.order?.Comments?.length ?? ""}</span>
                      </div>
                    </button>
                    <button
                      onClick={openModal}
                      className="font-normal text-xl text-themeBlue py-2 px-4 
                      flex items-center gap-x-2"
                    >
                      <span className="underline">Track Order</span>
                      <FaChevronRight />
                    </button>
                  </div>
                </div>
              </div>
              <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                <div className="flex justify-between items-center gap-x-4">
                  <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                    Package Details
                  </h1>
                  <FaChevronDown
                    onClick={openDropdown}
                    className={`${
                      dropdown ? "hidden" : "block"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                  <FaChevronUp
                    onClick={closeDropdown}
                    className={`${
                      dropdown ? "block" : "hidden"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                </div>
                <div className={dropdown ? "block" : "hidden"}>
                  <div className="grid gap-4">
                    <div className="bg-white shadow-lg rounded-lg px-5 py-6 flex flex-wrap gap-x-8">
                      <h2 className="text-lg font-semibold mb-2">
                        Total Packages
                      </h2>
                      <p>{data?.data?.order?.Packages?.length ?? ""}</p>
                      <h2 className="text-lg font-semibold mb-2">
                        Volume(cm3)
                      </h2>
                      <p>{data?.data?.volumetricWeight ?? ""}</p>
                      <h2 className="text-lg font-semibold mb-2">
                        Billable Weight (kg)
                      </h2>
                      <p>{data?.data?.captureBillableWeight ?? ""}</p>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mt-4">
                    {data?.data?.packages?.map((pp, index) => (
                      <div
                        key={index}
                        className="bg-white shadow-lg rounded-lg p-5"
                      >
                        <h2 className="text-lg font-semibold mb-2">
                          Package ID {pp?.id}
                        </h2>
                        <p>Length: {pp.captureLength}</p>
                        <p>Width: {pp.captureWidth}</p>
                        <p>Height: {pp.captureHeight}</p>
                        <p>Weight: {pp.captureWeight}</p>
                        <p>Quantity: {pp.qty}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                <div className="flex justify-between items-center gap-x-4">
                  <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                    Products Details
                  </h1>
                  <FaChevronDown
                    onClick={openDropdown1}
                    className={`${
                      dropdown1 ? "hidden" : "block"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                  <FaChevronUp
                    onClick={closeDropdown1}
                    className={`${
                      dropdown1 ? "block" : "hidden"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                </div>
                <div className={dropdown1 ? "block" : "hidden"}>
                  <div className="bg-white shadow-lg rounded-lg px-5 py-6 flex flex-wrap gap-x-8">
                    <h2 className="text-lg font-semibold mb-2">
                      No. of Products
                    </h2>
                    <p>{data?.data?.products?.length}</p>
                    <h2 className="text-lg font-semibold mb-2">
                      Total Weight(kg)
                    </h2>
                    <p>{data?.data?.product_weight}</p>
                    <h2 className="text-lg font-semibold mb-2">
                      Total Quantity
                    </h2>
                    <p>{data?.data?.product_qty}</p>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    {data?.data?.order?.Products?.map((product, index) => (
                      <div
                        key={index}
                        className="bg-white shadow-lg rounded-lg p-5"
                      >
                        <h2 className="text-lg font-semibold mb-2">
                          Product ID {product?.id}
                        </h2>
                        <p>Weight(Kg): {product.weight}</p>
                        <p>Qty: {product.qty}</p>
                        <p>Price($): {product.price}</p>
                        <p>HsCode: {product.HsCode?.HsCode}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                <div className="flex justify-between items-center gap-x-4">
                  <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                    Consolidation Details
                  </h1>
                  <FaChevronDown
                    onClick={openDropdown2}
                    className={`${
                      dropdown2 ? "hidden" : "block"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                  <FaChevronUp
                    onClick={closeDropdown2}
                    className={`${
                      dropdown2 ? "block" : "hidden"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                </div>
                <div className={dropdown2 ? "block" : "hidden"}>
                  <div className="grid gap-4">
                    <div className="bg-white shadow-lg rounded-lg px-5 py-6 flex flex-wrap gap-x-8">
                      <h2 className="text-lg font-semibold mb-2">
                        Volume(cm3)
                      </h2>
                      <p>
                        {data?.data?.ConsolidationPackage?.VolumetricWeight ??
                          ""}
                      </p>
                      <h2 className="text-lg font-semibold mb-2">
                        Billable Weight (kg)
                      </h2>
                      <p>
                        {data?.data?.ConsolidationPackage?.BillableWeight ?? ""}
                      </p>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="bg-white shadow-lg rounded-lg p-5">
                      <p>
                        Length:{" "}
                        {data?.data?.ConsolidationPackage?.measuredLength}
                      </p>
                      <p>
                        Width: {data?.data?.ConsolidationPackage?.measuredWidth}
                      </p>
                      <p>
                        Height:{" "}
                        {data?.data?.ConsolidationPackage?.measuredHeight}
                      </p>
                      <p>
                        Weight:{" "}
                        {data?.data?.ConsolidationPackage?.measuredWeight}
                      </p>
                      <p>
                        Quantity: {data?.data?.ConsolidationPackage?.quantity}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white shadow-lg rounded-lg px-5 py-6 flex flex-wrap gap-x-8 items-center align-baseline">
                <div className="flex items-center gap-2 text-center ">
                  <p className="text-lg font-semibold ">Origin Country</p>
                  <p>
                    {data?.data?.order?.CompanyCountry?.originCountry?.name}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <h2 className="text-lg font-semibold ">
                    Destination Country
                  </h2>
                  <p>
                    {
                      data?.data?.order?.CompanyCountry?.destinationCountry
                        ?.name
                    }
                  </p>
                </div>
              </div>
              <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                <div className="flex justify-between items-center gap-x-4">
                  <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                    Supplier Details
                  </h1>
                  <FaChevronDown
                    onClick={openDropdown3}
                    className={`${
                      dropdown3 ? "hidden" : "block"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                  <FaChevronUp
                    onClick={closeDropdown3}
                    className={`${
                      dropdown3 ? "block" : "hidden"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                </div>
                <div className={dropdown3 ? "block" : "hidden"}>
                  <table>
                    <tbody>
                      <tr>
                        <td className={tdStyle}>Tracking No</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.SupplierDetail?.trackingNo ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Tracking Link</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.SupplierDetail?.trackingLink ? (
                            <a
                              href={data.data.order.SupplierDetail.trackingLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "rgb(0, 102, 204)" }}
                            >
                              {data.data.order.SupplierDetail.trackingLink}
                            </a>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Name</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.SupplierDetail?.contactName ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Email</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.SupplierDetail?.email ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Phone</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.SupplierDetail?.phone ?? ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                <div className="flex justify-between items-center gap-x-4">
                  <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                    Consignee Details
                  </h1>
                  <FaChevronDown
                    onClick={openDropdown4}
                    className={`${
                      dropdown4 ? "hidden" : "block"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                  <FaChevronUp
                    onClick={closeDropdown4}
                    className={`${
                      dropdown4 ? "block" : "hidden"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                </div>
                <div className={dropdown4 ? "block" : "hidden"}>
                  <table>
                    <tbody>
                      <tr>
                        <td className={tdStyle}>Company</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.ConsigneeDetail?.companyName ??
                            ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Name</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.ConsigneeDetail?.contactName ??
                            ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Email</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.ConsigneeDetail?.email ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Phone</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.ConsigneeDetail?.phone ?? ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                <div className="flex justify-between items-center gap-x-4">
                  <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                    Destination Details
                  </h1>
                  <FaChevronDown
                    onClick={openDropdown5}
                    className={`${
                      dropdown5 ? "hidden" : "block"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                  <FaChevronUp
                    onClick={closeDropdown5}
                    className={`${
                      dropdown5 ? "block" : "hidden"
                    } text-black text-opacity-60 min-w-[16px] cursor-pointer`}
                  />
                </div>
                <div className={dropdown5 ? "block" : "hidden"}>
                  <table>
                    <tbody>
                      <tr>
                        <td className={tdStyle}>Company</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.DestinationDetail?.companyName ??
                            ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Address</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.DestinationDetail?.address ?? ""}{" "}
                        </td>
                      </tr>

                      <tr>
                        <td className={tdStyle}>Postal Code</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.DestinationDetail?.postalCode ??
                            ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>City</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.DestinationDetail?.city ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Province</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.DestinationDetail?.province ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <td className={tdStyle}>Country</td>
                        <td className={tdStyle2}>
                          {data?.data?.order?.DestinationDetail?.country ?? ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div>
              <div className="bg-white py-6 px-5 rounded-lg flex flex-col gap-y-20 min-h-[760px]">
                <h2 className="font-medium sm:text-3xl text-2xl text-themeRed">
                  Estd. Quote
                </h2>
                <ul className="space-y-6">
                  <li className="flex sm:flex-row flex-col justify-between sm:items-center gap-x-14">
                    <h6 className="font-normal xl:text-xl sm:text-lg text-base text-black text-opacity-40">
                      Freight Price ({data?.data?.kg} kg x $
                      {data?.data?.companyTax})
                    </h6>
                    <h5 className="font-bold xl:text-2xl text-lg">
                      ${data?.data?.order?.freightPrice ?? ""}
                    </h5>
                  </li>
                  <li className="flex sm:flex-row flex-col justify-between sm:items-center gap-x-14">
                    <h6 className="font-normal xl:text-xl sm:text-lg text-base text-black text-opacity-40">
                      Import VAT
                    </h6>
                    <h5 className="font-bold xl:text-2xl text-lg">
                      ${data?.data?.vatTax ?? ""}
                    </h5>
                  </li>
                  <li className="flex sm:flex-row flex-col justify-between sm:items-center gap-x-14">
                    <h6 className="font-normal xl:text-xl sm:text-lg text-base text-black text-opacity-40">
                      Import Duties
                    </h6>
                    <h5 className="font-bold xl:text-2xl text-lg">
                      ${data?.data?.importDuty ?? ""}
                    </h5>
                  </li>
                  <li className="flex sm:flex-row flex-col justify-between sm:items-center gap-x-14">
                    <h6 className="font-normal xl:text-xl sm:text-lg text-base text-black text-opacity-40">
                      Insurance
                    </h6>
                    <h5 className="font-bold xl:text-2xl text-lg">
                      ${data?.data?.insurance ?? ""}
                    </h5>
                  </li>
                  <li className="flex sm:flex-row flex-col justify-between sm:items-center gap-x-14">
                    <h6 className="font-normal xl:text-xl sm:text-lg text-base text-black text-opacity-40">
                      Repacking Fee
                    </h6>
                    <h5 className="font-bold xl:text-2xl text-lg">
                      $
                      {Number(data?.data?.order?.repackingPrice).toFixed(2) ??
                        ""}
                    </h5>
                  </li>
                  <li className="flex sm:flex-row flex-col justify-between sm:items-center gap-x-14">
                    <h6 className="font-normal xl:text-xl sm:text-lg text-base text-black text-opacity-40">
                      Customs Clearance Fee
                    </h6>
                    <h5 className="font-bold xl:text-2xl text-lg">
                      ${data?.data?.customerClearanceFee ?? ""}
                    </h5>
                  </li>
                </ul>
                <div>
                  <h1 className="font-bold sm:text-4xl text-xl text-end">
                    Est. Price : ${data?.data?.order?.totalPrice}
                  </h1>
                  <h1 className="font-bold sm:text-4xl text-xl text-end">
                    Confirmed Price : ${data?.data?.order?.confirmTotalPrice}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <div
        className={`${
          waybill ? "block" : "hidden"
        } absolute w-full print:h-full top-0 left-0 bg-black bg-opacity-60 z-[60] space-y-10 print:space-y-60`}
        id="content-id"
        data-waybill-root="true"
      >
        {data?.data?.order?.Packages?.map((pack, index) => (
          <div
            className={`waybill ${
              index !== 0 ? "print:page-break" : ""
            } waybill-card relative xl:w-4/6 lg:w-4/5 w-[96%] left-[50%] -translate-x-[50%] bg-white border border-black waybill`}
            key={pack.id}
          >
            <div
              className="border-2 border-black border-opacity-60 float-right 
                  rounded-fullest cursor-pointer sm:text-black h-6 w-6 inline-flex waybill-close
                  justify-center items-center mr-3 mt-3 print:hidden"
              onClick={closeWaybill}
            >
              <FontAwesomeIcon
                icon={faMultiply}
                className="text-black text-opacity-60"
              />
            </div>

            <div className="my-16 sm:px-8 px-4 py-12 sm:space-y-8 space-y-6 print:my-0 print:py-4">
              <h1
                className="font-medium sm:text-4
              xl text-3xl text-black text-opacity-60 text-center"
              >
                ORDER#{data?.data?.order?.id ?? ""}
              </h1>

              <div className="flex justify-center sm:gap-x-[33%] gap-x-[20%]">
                <div className="">
                  <img
                    src="images/logo2.webp"
                    className="md:w-56 sm:w-40 w-32 m-auto"
                    alt=""
                  />
                </div>
              </div>

              <div id={pack.id}>
                <div className="flex print:flex overflow-hidden justify-between">
                  <div className="space-y-2 print:w-1/2">
                    <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                      Expected Hub Arrival Date :{" "}
                      <span className="font-bold text-black">
                        <Moment format="D MMM , YYYY hh:mm a">
                          {data?.data?.order?.expectedHubArrivalDate}
                        </Moment>
                      </span>
                    </p>
                    <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                      Actual Hub Arrival Date:{" "}
                      <span
                        className="relative before:content-[''] before:absolute before:bottom-0 before:left-2 
                        before:w-28 before:h-0.5 before:bg-black"
                      ></span>
                    </p>
                  </div>
                  <div className="space-y-2 print:w-1/2 print:text-end">
                    <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                      Expected Consol Number:{" "}
                      <span className="font-bold text-black">28-11-2022</span>
                    </p>
                    <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                      Actual Console Number:{" "}
                      <span
                        className="relative before:content-[''] before:absolute before:bottom-0 before:left-2 
                        before:w-36 before:h-0.5 before:bg-black"
                      ></span>
                    </p>
                  </div>
                </div>
                <table className="my-2 w-full [&>thead>tr>th]:text-start border border-black [&>thead>tr>td]:border [&>thead>tr>td]:border-black [&>tbody>tr>td]:border [&>tbody>tr>td]:border-black">
                  <thead>
                    <tr>
                      <th></th>
                      <td className={tdStyle}>Length (cm)</td>
                      <td className={tdStyle}>Width (cm)</td>
                      <td className={tdStyle}>Height (cm)</td>
                      <td className={tdStyle}>Weight (kg)</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className={tdStyle}>Captured</td>
                      <td className={tdStyle}>{Number(pack.captureLength)}</td>
                      <td className={tdStyle}>{Number(pack.captureWidth)}</td>
                      <td className={tdStyle}>{Number(pack.captureHeight)}</td>
                      <td className={tdStyle}>{Number(pack.captureWeight)}</td>
                    </tr>
                    <tr>
                      <td className={tdStyle}>Measured</td>
                      <td className={tdStyle}>{Number(pack.measuredLength)}</td>
                      <td className={tdStyle}>{Number(pack.measuredWidth)}</td>
                      <td className={tdStyle}>{Number(pack.measuredHeight)}</td>
                      <td className={tdStyle}>{Number(pack.measuredWeight)}</td>
                    </tr>
                  </tbody>
                </table>
                <h1 className="font-normal sm:text-2xl text-lg text-center uppercase print:my-2 mt-2 mb-3">
                  Packages without a waybill attached will not be accepted
                </h1>
                <div className="mb-3">
                  <h1 className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 px-5 py-2">
                    Send Packages to below address
                  </h1>
                  <div
                    className="print:flex print:justify-between flex justify-between 
                    px-5 py-3 border border-black gap-y-5"
                  >
                    <div>
                      <ul className="[&>li]:font-normal [&>li]:text-base sm:space-y-3 space-y-1 ">
                        <li>{data?.data?.english_address?.address ?? ""}</li>
                        <li>{data?.data?.english_address?.city ?? ""}</li>
                        <li>{data?.data?.english_address?.state ?? ""}</li>
                        <li>{data?.data?.english_address?.zipCode ?? ""}</li>
                        <li>{data?.data?.english_address?.country ?? ""}</li>
                        <li>{data?.data?.english_address?.email ?? ""}</li>
                        <li>{data?.data?.english_address?.number ?? ""}</li>
                      </ul>
                    </div>
                    <div>
                      <ul className="[&>li]:font-normal [&>li]:text-base sm:space-y-3 space-y-1 ">
                        <li>{data?.data?.china_address?.address ?? ""}</li>
                        <li>{data?.data?.china_address?.city ?? ""}</li>
                        <li>{data?.data?.china_address?.state ?? ""}</li>
                        <li>{data?.data?.china_address?.zipCode ?? ""}</li>
                        <li>{data?.data?.china_address?.country ?? ""}</li>
                        <li>{data?.data?.china_address?.email ?? ""}</li>
                        <li>{data?.data?.china_address?.number ?? ""}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-x-5 sm:gap-y-8 gap-y-6 print:flex print:gap-x-5 mb-3">
                  <div className="print:w-1/2">
                    <h1
                      className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3
                      px-3 py-2 border border-black "
                    >
                      Supplier Details
                    </h1>
                    <div className="flex">
                      <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm">
                        <li className={liStyle}>Contact Name</li>
                        <li className={liStyle}>Company Name</li>
                        <li className={liStyle}>Email</li>
                        <li className={liStyle}>Number</li>
                      </ul>
                      <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm w-full">
                        <li className={liStyle}>
                          {data?.data?.order?.SupplierDetail?.contactName}
                        </li>
                        <li className={liStyle}>
                          {data?.data?.order?.SupplierDetail?.trackingNo}
                        </li>
                        <li className={liStyle}>
                          {data?.data?.order?.SupplierDetail?.email}
                        </li>
                        <li className={liStyle}>
                          {data?.data?.order?.SupplierDetail?.phone}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="print:w-1/2">
                    <h1
                      className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 
                      px-3 py-2 border border-black "
                    >
                      Consignee Details
                    </h1>
                    <div className="flex">
                      <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm">
                        <li className={liStyle}>Company</li>
                        <li className={liStyle}>Name</li>
                        <li className={liStyle}>Email</li>
                        <li className={liStyle}>Number</li>
                      </ul>
                      <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm w-full">
                        <li className={liStyle}>
                          {data?.data?.order?.ConsigneeDetail?.companyName}
                        </li>
                        <li className={liStyle}>
                          {data?.data?.order?.ConsigneeDetail?.contactName}
                        </li>
                        <li className={liStyle}>
                          {data?.data?.order?.ConsigneeDetail?.email}
                        </li>
                        <li className={liStyle}>
                          {data?.data?.order?.ConsigneeDetail?.phone}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <h1
                    className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 px-3 py-2  
                    border border-black "
                  >
                    Destination Details
                  </h1>
                  <div className="flex">
                    <ul>
                      <li className={liStyle}>Company</li>
                      <li className={liStyle}>Address</li>

                      <li className={liStyle}>Postal Code</li>
                      <li className={liStyle}>City</li>
                      <li className={liStyle}>Province</li>
                      <li className={liStyle}>Country</li>
                    </ul>
                    <ul className="w-full">
                      <li className={liStyle}>
                        {data?.data?.order?.DestinationDetail?.companyName}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.DestinationDetail?.address}
                      </li>

                      <li className={liStyle}>
                        {data?.data?.order?.DestinationDetail?.postalCode}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.DestinationDetail?.city}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.DestinationDetail?.province}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.DestinationDetail?.country}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
